import { CarbonUnit } from "../../utils/units/units";
import { classes } from "../../theme/theme";
import { ClickAwayListener, Tooltip } from "@mui/material";
import { CycleSlot } from "../../utils/metrics";
import { setCycleSlot } from "../../state/measurement";
import { useDispatch } from "react-redux";
import React, { FC, ReactNode, useState } from "react";

/**
 * @returns wraps the given children (which should be a UnitSpan) in a Tooltip
 * that allows the user to change their selected unit for the given cycleSlot
 **/
export const CycleTooltip: FC<{
  children: ReactNode;
  cycle: CarbonUnit[];
  cycleSlot: CycleSlot;
}> = ({ children: unit, cycle, cycleSlot }) => {
  const dispatch = useDispatch();
  const [isOpen, setOpen] = useState<boolean>(false);

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <Tooltip
        classes={{
          tooltip: "bg-darken-800 flex p-0",
        }}
        slotProps={{
          popper: {
            modifiers: [
              {
                name: "offset",
                options: {
                  offset: [0, -14],
                },
              },
            ],
          },
        }}
        open={isOpen}
        title={
          <>
            {cycle.map((unit) => (
              <button
                className="
                          bg-transparent border-0 hover:bg-lighten-100
                          p-2
                          text-xs text-white
                          cursor-pointer
                        "
                onClick={() => {
                  dispatch(setCycleSlot([cycleSlot, unit]));
                }}
                key={unit}
              >
                {unit}
              </button>
            ))}
          </>
        }
      >
        <div
          className={classes("cursor-ew-resize relative", {
            "bg-darken-800 text-white -m-1 p-1": isOpen,
          })}
          role="button"
          tabIndex={0}
          onClick={(event) => {
            event.stopPropagation();
            setOpen(!isOpen);
          }}
        >
          {unit}
        </div>
      </Tooltip>
    </ClickAwayListener>
  );
};
